{
  "hero.title": "マルチCLI環境スイッチャー",
  "hero.tagline-1": "禅のようなフロー状態でコーディング。",
  "hero.tagline-2": "シームレスな環境切り替え。",
  "hero.subtitle": "Claude Code、Codex、OpenCodeの設定を統合管理、APIプロキシ自動フェイルオーバー付き",
  "hero.getDocs": "ドキュメントを見る",
  "features.title": "機能",
  "features.multiCli.title": "マルチCLIサポート",
  "features.multiCli.desc": "Claude Code、Codex、OpenCodeをサポート、プロジェクトごとに設定可能",
  "features.multiConfig.title": "マルチ設定管理",
  "features.multiConfig.desc": "統一されたJSONファイルですべてのAPIプロバイダー設定を管理",
  "features.daemon.title": "統合デーモン",
  "features.daemon.desc": "単一のzendプロセスでプロキシサーバーとWeb管理UIを同時にホスト",
  "features.failover.title": "プロキシフェイルオーバー",
  "features.failover.desc": "内蔵HTTPプロキシ、プライマリプロバイダーが利用不可の場合は自動的にバックアップに切り替え",
  "features.routing.title": "シナリオルーティング",
  "features.routing.desc": "リクエスト特性（thinking、imageなど）に基づいて異なるプロバイダーにインテリジェントにルーティング",
  "features.binding.title": "プロジェクトバインディング",
  "features.binding.desc": "ディレクトリを特定のprofileとCLIにバインドし、プロジェクトレベルの自動設定を実現",
  "features.envVars.title": "環境変数",
  "features.envVars.desc": "プロバイダーレベルで各CLIの環境変数を個別に設定",
  "features.webUi.title": "Web UI",
  "features.webUi.desc": "ブラウザでビジュアル管理、パスワード保護アクセスをサポート",
  "features.webSecurity.title": "Webセキュリティ",
  "features.webSecurity.desc": "アクセスパスワード自動生成、セッション認証、RSA暗号化トークン転送",
  "features.configSync.title": "設定同期",
  "features.configSync.desc": "WebDAV/S3/GitHub経由でデバイス間で設定を同期、AES-256-GCM暗号化使用",
  "features.comingSoon": "さらなる機能を近日公開",
  "install.title": "クイックスタート",
  "install.step1.title": "GoZenをインストール",
  "install.step1.desc": "ワンラインインストールスクリプト",
  "install.step2.title": "プロバイダーを設定",
  "install.step2.desc": "最初のAPIプロバイダーを追加",
  "install.step3.title": "起動",
  "install.step3.desc": "デフォルト設定でCLIを起動",
  "commands.title": "コマンド一覧",
  "commands.command": "コマンド",
  "commands.description": "説明",
  "commands.items.start": "CLIを起動（プロジェクトバインディングまたはデフォルト設定を使用）",
  "commands.items.profile": "指定したprofileで起動",
  "commands.items.profilePick": "profileをインタラクティブに選択",
  "commands.items.cli": "指定したCLIを使用（claude/codex/opencode）",
  "commands.items.yes": "CLI権限を自動承認（claude --permission-mode acceptEdits, codex -a never）",
  "commands.items.use": "指定したプロバイダーを直接使用（プロキシなし）",
  "commands.items.pick": "プロバイダーをインタラクティブに選択して起動",
  "commands.items.list": "すべてのプロバイダーとprofileを一覧表示",
  "commands.items.configAddProvider": "新しいプロバイダーを追加",
  "commands.items.configAddProfile": "新しいprofileを追加",
  "commands.items.configDefaultClient": "デフォルトCLIクライアントを設定",
  "commands.items.configDefaultProfile": "デフォルトprofileを設定",
  "commands.items.configResetPassword": "Web UIアクセスパスワードをリセット",
  "commands.items.configSync": "リモート同期バックエンドから設定をプル",
  "commands.items.daemonStart": "zendデーモンを起動",
  "commands.items.daemonStop": "デーモンを停止",
  "commands.items.daemonStatus": "デーモンステータスを表示",
  "commands.items.daemonEnable": "システムサービスとしてインストール",
  "commands.items.daemonDisable": "システムサービスをアンインストール",
  "commands.items.bind": "現在のディレクトリをprofileにバインド",
  "commands.items.bindCli": "現在のディレクトリを指定したCLIにバインド",
  "commands.items.unbind": "現在のディレクトリのバインドを解除",
  "commands.items.status": "現在のディレクトリのバインドステータスを表示",
  "commands.items.web": "ブラウザでWeb管理UIを開く（デーモンを自動起動）",
  "commands.items.upgrade": "最新バージョンにアップグレード",
  "commands.items.version": "バージョンを表示",
  "commands.items.completion": "シェル補完スクリプトを生成（zsh/bash/fish）",
  "homepage.title": "マルチCLI環境スイッチャー"
}
